module.exports = __webpack_public_path__ + "img/13.ecae58bb.png";